import TaxiCorporationPlanEntryBillingsDownloadResponse from "../../../../api/raily/taxi-corporation/plan-entry-billings/download/taxi-corporation-plan-entry-billings-download.response";
import TaxiCorporationPlanEntryBillingsDownload from "./taxi-corporation-plan-entry-billings-download";

const create = (
  response: TaxiCorporationPlanEntryBillingsDownloadResponse,
): TaxiCorporationPlanEntryBillingsDownload => {
  return {
    data: response.data.data,
    filename: response.data.filename,
  };
};

const taxiCorporationPlanEntryBillingsDownloadFactory = {
  create,
};

export default taxiCorporationPlanEntryBillingsDownloadFactory;
